import { createStore, combineReducers, applyMiddleware } from 'redux';
import {thunk} from 'redux-thunk';  // Correct import for thunk
import authReducer from './reducers/authReducer';
import carReducer from './reducers/carReducer';
import paymentReducer from './reducers/paymentReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  carDetails: carReducer,  // Ensure this matches the `useSelector` key in your component
  payment: paymentReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
